import { render, staticRenderFns } from "./TransferMock.vue?vue&type=template&id=6738d610&scoped=true"
import script from "./TransferMock.vue?vue&type=script&lang=js"
export * from "./TransferMock.vue?vue&type=script&lang=js"
import style0 from "./TransferMock.vue?vue&type=style&index=0&id=6738d610&prod&lang=less&scoped=true"
import style1 from "./TransferMock.vue?vue&type=style&index=1&id=6738d610&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6738d610",
  null
  
)

export default component.exports